import '@firebase/messaging';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase/messaging/dist/index.esm.js
// module id = 448
// module chunks = 10